<template>
  <div
    ref="bannerRef"
    class="listing-banner-universal-tags"
  >
    <div class="images">
      <ui-image
        class="images__main"
        :src="props.banner?.image_main"
        :alt="t('bannerInjection.mainPhoto')"
        loading="lazy"
        fit="cover"
        decoding="async"
      />
      <ui-image
        class="images__sub"
        :src="props.banner?.image_sub"
        :alt="t('bannerInjection.subPhoto')"
        loading="lazy"
        fit="cover"
        decoding="async"
      />
    </div>

    <div class="info">
      <div
        class="info__title"
        v-html="props.banner.title"
      />
      <banner-tags
        :tags="tags"
        @on-click="emit('onClick')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import BannerTags from './BannerTags.vue';
  import type { GetListingBannersItemBannerParamsResponse, ListingBannersButton } from '@/shared/api/experience';
  import { useI18n } from '@experience/i18n';
  import { UiImage } from '@experience/core-image-ui';
  import ru from '../i18n/ru.json';

  interface Props {
    banner: GetListingBannersItemBannerParamsResponse;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<{ onClick: [] }>();

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const tags = computed(() => (props.banner?.tags || []) as ListingBannersButton[]);
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as typography;

  .listing-banner-universal-tags {
    display: flex;
    flex-direction: column;
  }

  .info {
    padding: 24px;
  }

  .info__title {
    margin-bottom: 16px;

    @include typography.base-700-500-extra;
  }

  .info__description {
    margin-bottom: 16px;

    @include typography.base-400-400-regular;
  }

  .info__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .images {
    --sub-photo-width: 114px;
    --gap-between-imgs: 4px;
    display: flex;
    flex-grow: 1;
    gap: var(--gap-between-imgs);
    min-height: 0;
  }

  .images__main {
    object-fit: cover;
    width: calc(100% - var(--sub-photo-width) - var(--gap-between-imgs));
  }

  .images__sub {
    object-fit: cover;
    width: var(--sub-photo-width);
    height: 130px !important;
  }
</style>
